/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 5.0.3
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */

/**
 * @module BlockPair
 */
class BlockPair {
  #ecCodewords;
  #dataCodewords;
  constructor(dataCodewords, ecCodewords) {
    this.#ecCodewords = ecCodewords;
    this.#dataCodewords = dataCodewords;
  }
  get ecCodewords() {
    return this.#ecCodewords;
  }
  get dataCodewords() {
    return this.#dataCodewords;
  }
}

export { BlockPair };
